<template>
  <b-modal
    id="booking-add-weekly-recurrence-modal"
    size="lg"
    :title="trans('recurrence')"
    :ok-title="trans('add')"
    :ok-disabled="!canAdd"
    :cancel-title="trans('cancel')"
    @hidden="onHidden"
    @show="onShown"
    @ok="onAdd"
  >
    <b-row>
      <b-col>
        <b-row>
          <b-col>
            <b-form-group :label="trans('start')">
              <datetime
                v-model="date"
                class="form-control-sm"
                :config="dateOptions"
                :placeholder="trans('start')"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group :label="trans('weeks')">
              <b-form-input
                type="number"
                v-model="count"
                size="sm"
                min="1"
                max="20"
                autocomplete="off"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-for="(day, index) in orderedDays" :key="day.id">
          <b-col>
            <b-form-group>
              <b-form-checkbox v-model="day.active">
                {{ day.label }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group>
              <datetime
                v-model="day.time"
                class="form-control-sm"
                :config="timeOptions"
                :placeholder="trans('start')"
                :disabled="!day.active"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-group :label="trans('duration')">
          <duration
            v-model="duration"
            size="sm"
            :max-hours="18"
          ></duration>
        </b-form-group>
      </b-col>
      <b-col>
        <label class="d-block">
          {{ trans('schedule') }}
        </label>
        <p v-if="serialized.length == 0">
          <em>{{ trans('select_days_of_the_week') }}</em>
        </p>
        <label v-for="(d, index) in serialized" :key="index" class="d-block">
          {{ moment(d).format('dddd LLL') }}
        </label>
      </b-col>
    </b-row>
    <b-form-group :label="trans('locations')">
      <treeselect
        :options="locationOptions"
        :placeholder="trans('locations')"
        multiple
        v-model="location_ids"
      ></treeselect>
    </b-form-group>
  </b-modal>
</template>

<script>
  import Datetime from 'vue-bootstrap-datetimepicker'
  import Duration from './../class/DurationHoursMinutes'
  import Treeselect from '@riophae/vue-treeselect'

  const format = 'ddd MMM D, YYYY'
  function buildDays(date) {
    let m = date ? // ISO date string expected
      moment(date) :
      moment().startOf('hour')
    let time = m.format('LT')
    let active = false
    return [
      {day: 1, label: _.weekdayLabel(1), time: time, active: active}, // Monday
      {day: 2, label: _.weekdayLabel(2), time: time, active: active}, // Tuesday
      {day: 3, label: _.weekdayLabel(3), time: time, active: active}, // Wednesday
      {day: 4, label: _.weekdayLabel(4), time: time, active: active}, // Thursday
      {day: 5, label: _.weekdayLabel(5), time: time, active: active}, // Friday
      {day: 6, label: _.weekdayLabel(6), time: time, active: active}, // Saturday
      {day: 0, label: _.weekdayLabel(0), time: time, active: active}, // Sunday
    ]
  }

  export default {
    props: {
      organization: Object,
      initialStart: String, // ISO date string please
      initialLocationIds: Array,
      initialDuration: Number, // minutes
      durationOptions: Array,
      locations: Array,
    },
    components: {
      Datetime,
      Duration,
      Treeselect,
    },
    data() {
      let date = !!this.initialStart ?
        moment(this.initialStart).format(format) :
        moment().startOf('hour').format(format)
      return {
        trans: trans,
        moment: moment,
        date: date,
        dateOptions: {
          locale: window.lang,
          format: format,
          showClear: true,
        },
        count: 2,
        days: buildDays(this.initialStart || moment().startOf('hour').toISOString()),
        timeOptions: {
          locale: window.lang,
          format: 'LT',
          stepping: 1,
        },
        duration: this.initialDuration || 60, // in minutes
        location_ids: [],
      }
    },
    computed: {
      locationOptions() {
        return _.map(this.locations || [], l => {
          return {
            id: l.id,
            label: l.name,
          }
        })
      },
      orderedDays() {
        let m = this.date ?
          moment(this.date, format).startOf('hour') :
          moment().startOf('hour')
        let day = m.day()
        let days = []
        for (let i = day; i < 7; i++) {
          days.push(_.find(this.days, {day: i}))
        }
        for (let i = 0; i < day; i++) {
          days.push(_.find(this.days, {day: i}))
        }
        return days
      },
      serialized() {
        let start = moment(this.date, format)
        let firstDay = start.day()
        let days = _.reduce(this.orderedDays, (days, day) => {
          if (day.active) {
            let date = moment(start).day(day.day)
            if (day.day < firstDay) date.add(7, 'days')
            let time = moment(day.time, 'LT')
            date.hour(time.hour())
            date.minute(time.minute())
            date.second(0)
            days.push(date.toISOString())
          }
          return days
        }, [])
        let dates = []
        for (let i = 0; i < this.count; i++) {
          dates = _.reduce(days, (dates, date) => {
            dates.push(moment(date).add(7*i, 'days'))
            return dates
          }, dates)
        }
        return dates
      },
      canAdd() {
        return !!this.date && this.location_ids.length > 0 && this.serialized.length > 0
      },
    },
    methods: {
      onAdd() {
        this.$emit('add', this.serialized, this.location_ids, this.duration)
      },
      onHidden() {
        this.count = 2
      },
      onShown() {
        if (!!this.initialStart)
          this.date = moment(this.initialStart).format(format)
        if (!!this.initialDuration)
          this.duration = this.initialDuration
        this.days = buildDays(this.initialStart || moment().startOf('hour').toISOString())
        if (!!this.initialLocationIds)
          this.location_ids = _.clone(this.initialLocationIds)
      },
    },
    mounted() {
      window.addWeeklyRecurrenceModal = this
    },
  }
</script>
